import Button from "./ui/Button";

/* Shown by the error boundaries when a page fails to render — most often a
   page chunk that could not load after a new deploy. Reloading fetches the
   current build, so the only action offered is a user-triggered refresh;
   nothing reloads on its own.

   fullPage: true for the app-wide boundary in index.js (nothing else is on
   screen); false for the per-route boundaries, which sit inside the layout. */
const ErrorFallback = ({ error, fullPage = false }) => (
  <div
    role="alert"
    className={[
      "tw-flex tw-w-full tw-items-center tw-justify-center tw-p-4",
      fullPage ? "tw-min-h-screen tw-bg-[#F5F7FB]" : "tw-min-h-[60vh]",
    ].join(" ")}
  >
    <div className="tw-w-full tw-max-w-[520px] tw-rounded-brand tw-border tw-border-solid tw-border-line-subtle tw-bg-surface tw-p-6 tw-text-center tw-text-ink tw-shadow-card sm:tw-p-8">
      <span
        aria-hidden="true"
        className="tw-mx-auto tw-mb-4 tw-flex tw-h-14 tw-w-14 tw-items-center tw-justify-center tw-rounded-full tw-bg-brand-red/10 tw-text-2xl tw-text-brand-red"
      >
        <i className="fa fa-exclamation-triangle" />
      </span>
      <h2 className="tw-mb-2 tw-w-auto tw-font-header tw-text-22 tw-font-semibold tw-text-brand-navy">
        Something went wrong
      </h2>
      <p className="tw-mb-5 tw-text-sm tw-text-ink-secondary">
        An unexpected error occurred while displaying this page. Please refresh
        the application to continue.
      </p>
      <div className="tw-flex tw-justify-center">
        <Button variant="secondary" onClick={() => window.location.reload()}>
          <i className="fa fa-refresh" aria-hidden="true" /> Refresh
          Application
        </Button>
      </div>
      {error?.message && (
        <details className="tw-mt-5 tw-text-left tw-text-xs tw-text-ink-secondary">
          <summary className="tw-cursor-pointer tw-text-center">
            Technical details
          </summary>
          <pre className="tw-mt-2 tw-mb-0 tw-max-h-40 tw-overflow-auto tw-whitespace-pre-wrap tw-break-words tw-rounded-md10 tw-bg-[#F5F7FB] tw-p-3 tw-text-xs">
            {error.message}
          </pre>
        </details>
      )}
    </div>
  </div>
);

export default ErrorFallback;
